import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  max-width: 600px;
  max-height: 215px;
  padding: 10px;
  font-size: 10px;
  border-radius: 10px;
  background-color: #e9eaec;
  overflow-x: scroll;
  overflow-y: hidden;
  margin: auto;
`;

export default Container;
